import { gql } from '@apollo/client';

export const CREATE_STAKEHOLDERS = gql`
  mutation createStakeholders($inputs: CreateStakeholdersInput!) {
    stakeholders: createStakeholders(inputs: $inputs) {
      id
    }
  }
`;
